import {zx} from 'shared/type'
import {z} from 'zod'
import {match} from 'ts-pattern'

const commentStatus = ['issue-critical', 'issue-minor', 'question'] as const
export const zCommentStatus = z.enum(commentStatus)
export type CommentStatus = (typeof commentStatus)[number]

const commentTypes = ['forecast-note'] as const
const zCommentType = z.preprocess(
  s =>
    match(s)
      // backwards compat. no longer use these types
      .with('cause-question', 'question', 'cause-forecast', () => undefined)
      .otherwise(() => s),
  z.enum(commentTypes).optional()
)

export const zCommentCfg = z.object({
  text: z.string().default(''),
  status: z.array(zCommentStatus).default([]),
  resolved: z.boolean().optional(),
  type: zCommentType.optional(),
  forecast_id: zx.nullish.string
})

export type CommentCfg = z.infer<typeof zCommentCfg>

export const zCommentRow = z.object({
  id: z.string(),
  question_id: z.string(),
  subquestion_id: zx.nullish.string,
  subquestions: zx.nullishToUndefined(z.array(z.string())),
  parent_id: zx.nullish.string,
  cfg: zCommentCfg,
  deleted: z.boolean().default(false),
  created_at: z.string(),
  created_by: z.string(),
  updated_at: z.string()
})
export type CommentRow = z.infer<typeof zCommentRow>

export const zCommentPut = zCommentRow.pick({id: true, cfg: true, question_id: true})
export type CommentPut = z.infer<typeof zCommentPut>
export const zCommentPost = zCommentRow.omit({
  id: true,
  updated_at: true,
  created_by: true,
  created_at: true,
  deleted: true,
  subquestions: true
})
export type CommentPost = z.infer<typeof zCommentPost>
